import { render, staticRenderFns } from "./EmployeeV2.vue?vue&type=template&id=dc1d2118"
import script from "./EmployeeV2.vue?vue&type=script&lang=js"
export * from "./EmployeeV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports